import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import TempoMedioPreenchimentoVagaStore from "../stores/TempoMedioPreenchimentoVagaStore";
import {LoadingBlockFields} from  "../../comum/components/LoadingBlockFields";
import {MensagemErro} from "../../comum/components/MensagemErro";
import DataWrapper from "../../principal/containers/DataWrapper";
import {Filtro} from "../../comum/components/Filtro";
import {Row, Col} from 'reactstrap';
import {CustomBarChart} from "../../comum/components/CustomBarChart";
import {getCoresAzuisCinzaOuAleatoria} from "../../../utils/functions";

const FILTROS = ['EMPRESA', 'COMPETENCIA_INICIO', 'COMPETENCIA_FIM'];

@inject("store")
@DataWrapper
@observer
export class TempoMedioPreenchimentoVaga extends Component {
    constructor(props) {
        super(props);
        this.controller = new TempoMedioPreenchimentoVagaStore();
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Tempo médio de preenchimento das vagas");
    }

    render() {
        return (
            <div className="form-wrapper">
                <div className="content-panel">
                    <MensagemErro>
                        {this.controller.erro}
                    </MensagemErro>
                    <LoadingBlockFields carregando={this.controller.carregando}>
                        <Filtro onSubmit={(filtro) => this.controller.filtrar(filtro)}
                                history={this.props.history}
                                location={this.props.location}
                                controller={this.controller}
                                fields={FILTROS} />
                        <Row>
                            <Col xs={12} md={12} lg={10}>
                                <CustomBarChart stackId="1" dataKeys={this.controller.empresasGlobo} data={this.controller.dados} customColor={getCoresAzuisCinzaOuAleatoria}
                                        labelAxisX={"Fornecedor"} labelAxisY={"Tempo médio (dias)"} />
                            </Col>
                        </Row>
                    </LoadingBlockFields>
                </div>
            </div>
        )
    }
}
